import { useQuery } from "react-query";
import Currency from "../apiResources/Currency";

export const useCurrencies = () => {
  return useQuery(["currencies"], async () => (await Currency.all()).data, {
    refetchOnWindowFocus: false,
  });
};
